module.exports = __webpack_public_path__ + "img/error.4fc6b782.svg";